<template v-if="isLoading">
	<sf-data-table 
		ref="grpTable"
		:paging="false"
		:excel="isButton_(scrId, 'EX')"
		:columns="mtbClos"
		:rows="rows"
		:stripe="false"
		:selection="false"
		:span-method="spanMethod"
		:pageUnit="groups.pageUnit"
		:totalSize="groups.totalSize"
		:showSummary="true"
		:summaryMethod="showSummaryData"
		:key="doLayoutIndex"
		@changedPage="changedPage"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@pqy/pcku/MdjMGraph/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			monthlabel: '',
			cuRslt: '',
			bfRslt: '',
			mtbClos: [],
			doLayoutIndex: 0,
		};
	},
	created() {
		this.monthlabel = this.monthlabel_;
	},

	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.mdjTbList;
		},
		cols() {
			return this.mdjMTbCols;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		doLayoutTb(){
			this.doLayoutIndex++;
		},
		resetPage(){
			this.$refs.grpTable.setPage(1);
			this.$refs.grpTable.currentPage = 1;
		},
		spanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				let rowSize = this.mdjTbList.length;
				if (rowIndex % rowSize === 0) {
					return {
						rowspan: rowSize,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				};
			}
		},
		getMdjStatisticCode(){
			this.postSearchColList_()
			.then(header => {
				this.refreshCols();
				this.$emit('Refresh');
			})
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				Promise.reject(error);
			})
			.finally(() => {
				this.$sf_toggleLoading(false);
			});
			
		},
		showSummaryData({ columns, data }) {
			const sums = [];
			let ngCdMap = new Map();
			let ngCauseMap = new Map();
			for(let i = 0; i < this.ngCdList.length; i++){
				ngCdMap.set(this.ngCdList[i].cd, this.ngCdList[i].ngNum);
			}
			for(let j = 0; j < this.ngCauseList.length; j++){
				ngCauseMap.set(this.ngCauseList[j].cd, this.ngCauseList[j].ngNum);
			}
			for(let index = 0 ; index < columns.length; index++){
				if (index === 1) {
					sums[index] = 'Total';
					continue;
				}
				if(index === 0 || index === 2){
					sums[index] = '';
					continue;
				}
				
				let cd = columns[index].property;
				let ngNum = 0;
				if(index === 3 || index === 4 || index === 5){
					ngNum = ngCdMap.get(cd);
				}else{
					ngNum = ngCauseMap.get(cd);
				}
				sums[index] = ngNum ? ngNum : 0;
			}
        	return sums;
		},
		refreshCols(){
			const partType = this.searchParams.partType;
			//部品类型
			let partTypeCol = {
				label: this.getMessage_('QWCC000059'), 
				prop: 'qmsCommCd',
				width: '130px',
				align: 'center',
				sortable: false
			};
			//区分
			let itemCol = {
				label: this.getMessage_('QWCC002128'), 
				prop: 'itemNm',
				minWidth: '100px',
				align: 'center',
				sortable: false,
				children: [
					//MEA ID  EGA ID 
					{
						label: partType + ' ID',  
						prop: 'cellId',
						width: '180px',
						headerAlign: 'center',
						align: 'center'
					},
					//生产日
					{
						label: this.getMessage_('QWCC001722'), 
						prop: 'rptDt',
						width: '110px',
						headerAlign: 'center',
						align: 'center'
					}
				]
			};
			let ngTypeChildCols = [];
			for(let i = 0; i < this.ngType.length; i++){
				let currNgType = this.ngType[i];
				let ngTypeChildCol = {
						label: currNgType.commCdName,  
						prop:  currNgType.commCd,										//'qmsDefectCd',
						width: '90px',
						headerAlign: 'center',
						align: 'center',
						//className: currNgType.commCd,
						custom: false
				};
				ngTypeChildCols.push(ngTypeChildCol);
			}
			//不良区分
			let ngTypeCol = {
				label: this.getMessage_('QWCC001033'), 
				prop: 'bfRslt',
				minWidth: '100px',
				align: 'center',
				sortable: false,
				custom: true,
				children: ngTypeChildCols
			};
			let ngItemChildCols = [];
			let ngItemLabels = [];
			let ngItemArray = this.ngItem.get(partType);
			for(let i = 0; i < ngItemArray.length; i++){
				let currNgItem = ngItemArray[i];
				let ngItemChildCol = {
						label: currNgItem.commCdName,  
						prop: currNgItem.commCd,                    //'qmsDefectCause',
						headerAlign: 'center',
						align: 'center',
						width: '110px',
						labelClassName: 'line-feed',
						//showOverflowTooltip: true,
						custom: false,
						//className: currNgItem.commCd
				};
				ngItemChildCols.push(ngItemChildCol);
				ngItemLabels.push(currNgItem.commCdName);
			}
			//不良类型
			let ngItemCol = {
				label: this.getMessage_('QWCC001467'), 
				prop: 'cuRslt',
				minWidth: '100px',
				align: 'center',
				sortable: false,
				custom: true,
				children: ngItemChildCols
			};
			const cols = [];
			cols.push(partTypeCol);
			cols.push(itemCol);
			cols.push(ngTypeCol);
			cols.push(ngItemCol);
			this.mtbClos = cols;
			this.setState_({ key: 'barChartLabel', value: ngItemLabels });
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if(pageUnitVal != prePageUnit){
				currentPageVal = 1;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.searchTable();
		},
		searchTable(){
			this.$sf_toggleLoading(true);
			this.getMdjMList_().then(header => {
				
			})
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				Promise.reject(error);
			}).finally(() => {
				this.$sf_toggleLoading(false);
			});
		}
		
	},
	async created() {
		this.getMdjStatisticCode();
	}
};
</script>

<style>
.line-feed {
	white-space: normal !important;
  	word-break: break-word !important;
	height: auto !important;
}
.h-100{
	height:auto;
}

</style>
